<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        status: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , accion: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , statusprecontacto: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , postest: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , canalaceptacion: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , tipo: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        descripcion: []
        , payfac: []
        , gaps: []
        , status: []
        , accion: []
        , statusprecontacto: []
        , postest: []
        , canalaceptacion: []
        , tipo: []
        , clonable: []
      }
      , options: [
        {
          code: "descripcion"
          , name: this.$t("view.operativos.substatus.filters.descripcion")
          , icon: "fas fa-audio-description"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "payfac"
          , name: this.$t("view.operativos.substatus.filters.payfac")
          , icon: "fas fa-credit-card"
          , type: "sino"
          , selected: false
          , disabled: false
        }
        , {
          code: "gaps"
          , name: this.$t("view.operativos.substatus.filters.gaps")
          , icon: "fas fa-store theme--light"
          , type: "sino"
          , selected: false
          , disabled: false
        }
        , {
          code: "status"
          , name: this.$t("view.operativos.substatus.filters.status")
          , icon: "fas fa-check"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "accion"
          , name: this.$t("view.operativos.substatus.filters.accion")
          , icon: "fas fa-hand-pointer"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "statusprecontacto"
          , name: this.$t("view.operativos.substatus.filters.statusprecontacto")
          , icon: "fas fa-lightbulb"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "postest"
          , name: this.$t("view.operativos.substatus.filters.postest")
          , icon: "fas fa-question-circle"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "canalaceptacion"
          , name: this.$t("view.operativos.substatus.filters.canalaceptacion")
          , icon: "fas fa-vote-yea"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "tipo"
          , name: this.$t("view.operativos.substatus.filters.tipo")
          , icon: "fas fa-clipboard-list"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "clonable"
          , name: this.$t("view.operativos.substatus.filters.clonable")
          , icon: "fas fa-clone"
          , type: "sino"
          , selected: false
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectStatus();
        this.loadSelectAccion();
        this.loadSelectStatusPreContacto();
        this.loadSelectPostest();
        this.loadSelectCanalAceptacion();
        this.loadSelectTipo();
        if (this.select.status.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectStatus() {
      const { data: { results: { combo: statusList } } } = await CombosAPI.get({ option: "status" });
      this.select.status.filteredList = statusList || [];
      this.select.status.completeList = statusList || [];
    }
    , async loadSelectAccion() {
      const { data: { results: { combo: accionList } } } = await CombosAPI.get({ option: "accion" });
      this.select.accion.filteredList = accionList || [];
      this.select.accion.completeList = accionList || [];
    }
    , async loadSelectStatusPreContacto() {
      const { data: { results: { combo: statusprecontactoList } } } = await CombosAPI.get({ option: "statusprecontacto" });
      this.select.statusprecontacto.filteredList = statusprecontactoList || [];
      this.select.statusprecontacto.completeList = statusprecontactoList || [];
    }
    , async loadSelectPostest() {
      const { data: { results: { combo: postestList } } } = await CombosAPI.get({ option: "postest" });
      this.select.postest.filteredList = postestList || [];
      this.select.postest.completeList = postestList || [];
    }
    , async loadSelectCanalAceptacion() {
      const { data: { results: { combo: canalaceptacionList } } } = await CombosAPI.get({ option: "canalaceptacion" });
      this.select.canalaceptacion.filteredList = canalaceptacionList || [];
      this.select.canalaceptacion.completeList = canalaceptacionList || [];
    }
    , async loadSelectTipo() {
      const { data: { results: { combo: tipoList } } } = await CombosAPI.get({ option: "tipo" });
      this.select.tipo.filteredList = tipoList || [];
      this.select.tipo.completeList = tipoList || [];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/substatus/Filters.vue